// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Legend__svgContainer___zMEz9 {
    margin-right: 0;
    margin-left: auto;
}

.Legend__headerText___Svyuw {
    overflow: hidden;

    font-size: 1.2rem;
    color: var(--color-typo-secondary);
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.Legend__isDefined___iyAuT {
        color: var(--color-typo-primary);
    }
}

.Legend__scaleText___b5Iop {
    font-size: 1rem;
    fill: #00203399;
}

.Legend__headerTextBlock___vA017 {
    margin-top: 0.8rem;
}

.Legend__headerTooltipText___cIy3Z {
    display: flex;
    flex-direction: column;
    overflow-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/Legend/Legend.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;;IAEhB,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B","sourcesContent":[".svgContainer {\n    margin-right: 0;\n    margin-left: auto;\n}\n\n.headerText {\n    overflow: hidden;\n\n    font-size: 1.2rem;\n    color: var(--color-typo-secondary);\n    text-align: center;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &.isDefined {\n        color: var(--color-typo-primary);\n    }\n}\n\n.scaleText {\n    font-size: 1rem;\n    fill: #00203399;\n}\n\n.headerTextBlock {\n    margin-top: 0.8rem;\n}\n\n.headerTooltipText {\n    display: flex;\n    flex-direction: column;\n    overflow-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svgContainer": `Legend__svgContainer___zMEz9`,
	"headerText": `Legend__headerText___Svyuw`,
	"isDefined": `Legend__isDefined___iyAuT`,
	"scaleText": `Legend__scaleText___b5Iop`,
	"headerTextBlock": `Legend__headerTextBlock___vA017`,
	"headerTooltipText": `Legend__headerTooltipText___cIy3Z`
};
export default ___CSS_LOADER_EXPORT___;
